<template>
  <div
    :class="[
      'tw-p-8 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-min-h-[250px] md:tw-min-h-[280px] tw-shadow-lg',
      theme === 'dark' ? 'tw-bg-[#2d6a4f] tw-text-white' : 'tw-border tw-border-[#2d6a4f]',
      borderRadiusClass
    ]"
  >
    <img 
      v-if="iconUrl" 
      :src="iconUrl" 
      :class="[
        'tw-w-10 tw-h-10 tw-mb-4',
        theme === 'dark' ? 'tw-brightness-0 tw-invert' : '',
        iconClass
      ]" 
      alt="" 
    />
    <slot name="icon"></slot>

    <h3 
      v-if="title" 
      :class="[
        'tw-font-semibold tw-text-lg lg:tw-text-xl', 
        theme === 'light' ? 'tw-text-[#2d6a4f]' : '',
        description ? 'tw-mb-3' : '',
        titleClass
      ]"
    >{{ title }}</h3>
    <slot name="title"></slot>

    <p 
      v-if="description" 
      :class="[
        'tw-text-sm tw-font-light tw-leading-relaxed tw-px-2',
        theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-700',
        descriptionClass
      ]"
    >{{ description }}</p>
    <slot name="description"></slot>
    
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  theme?: 'light' | 'dark';
  roundedCorner?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'all';
  iconUrl?: string;
  iconClass?: string;
  title?: string;
  titleClass?: string;
  description?: string;
  descriptionClass?: string;
}>();

const borderRadiusClass = computed(() => {
  const baseClasses = 'tw-rounded-[40px]';

  if (props.roundedCorner === 'all') {
    return baseClasses;
  }
  
  if (props.roundedCorner === 'top-left') {
    return `${baseClasses} md:tw-rounded-tl-[40px] md:tw-rounded-tr-[4px] md:tw-rounded-br-[4px] md:tw-rounded-bl-[4px]`;
  }
  if (props.roundedCorner === 'top-right') {
    return `${baseClasses} md:tw-rounded-tl-[4px] md:tw-rounded-tr-[40px] md:tw-rounded-br-[4px] md:tw-rounded-bl-[4px]`;
  }
  if (props.roundedCorner === 'bottom-left') {
    return `${baseClasses} md:tw-rounded-tl-[4px] md:tw-rounded-tr-[4px] md:tw-rounded-br-[4px] md:tw-rounded-bl-[40px]`;
  }
  if (props.roundedCorner === 'bottom-right') {
    return `${baseClasses} md:tw-rounded-tl-[4px] md:tw-rounded-tr-[4px] md:tw-rounded-br-[40px] md:tw-rounded-bl-[4px]`;
  }

  return baseClasses;
});
</script>
